import React, { createContext, useEffect, useRef, useState } from "react";
import {
	OrderInner,
	OrderPageNavigationImg,
	OrderPageNavigationInner,
	OrderPageNavigationWrap,
} from "../../../Order/styled/OrderStyle";
import { getUseListOrder } from "../../hook/ListOrder";
import {
	BookingContentName,
	BookingContentWrap,
	MyBookingContainerMobi,
	MyBookingTableContainer,
	MyBookingTableContainerAdmin,
	AdminTransactionAddButtton,
} from "../../styled/DesStyled";
import { OrderStatus, PriceDetail, VerificationStatus } from "../../../../../models/Order";
import { Checkbox, Table, TableBody, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { CommonTableHeadCell } from "../../../../controls/components/commonTable/CommonTable";
import BookingTableBody from "../BookingTableBody";
import DialogUpdateOrderAdmin from "../../AdminBooking/UpdateOrderAdmin";
import BookingMobi from "../BookingMobi";
import BookingTableBodyAdmin from "./BookingTableBodyAdmin";
import DialogInfoBookingAdmin from "./DialogInfoBookingAdmin";
import useAlertDialog from "../../../../hooks/useAlertDialog";
import { AlertType } from "../../../../hooks/common/useAttachAlertDialog";
import {
	adminVerifyOrderOverride,
	BulkSendBookingEmailByAdmin,
	getAdminOrderDisputes,
} from "../../../../../services/OrderService";
import useLoadedUser from "../../../../hooks/auth/useLoadedUser";
import { UserRole } from "../../../../../models/User";

export default function BookingTableAdmin(props: { listOrder: PriceDetail[]; reload: () => void }) {
	const [isDialogLoginOpen, setIsDialogLoginOpen] = useState(false);
	const [orderId, setOrderId] = useState(0);
	const [isDialogIfOpen, setIsDialogIfOpen] = useState(false);
	const [orderIdInfo, setOrderIdInfo] = useState(0);
	const [selectedOrderIds, setSelectedOrderIds] = useState<number[]>([]);
	const [isSendingBookingEmails, setIsSendingBookingEmails] = useState(false);
	/* Nhãn "Disputed" theo trang đơn đang hiện (17/10/2026). */
	const [disputes, setDisputes] = useState<Record<string, any>>({});
	useEffect(() => {
		let alive = true;
		getAdminOrderDisputes(props.listOrder.map((o) => Number(o.id))).then((m) => alive && setDisputes(m));
		return () => {
			alive = false;
		};
	}, [props.listOrder]);
	const [isBulkVerifying, setIsBulkVerifying] = useState(false);
	const tableContainerRef = useRef<HTMLDivElement | null>(null);
	const { openAlertDialog } = useAlertDialog();
	const { user } = useLoadedUser();
	const columnWidths = {
		selection: 72,
		id: 80,
		location: 460,
		customer: 320,
		quantity: 100,
		total: 130,
		startDate: 120,
		endDate: 120,
		status: 150,
		verification: 200,
		createdAt: 200,
		actions: 170,
	};
	const emailResendableOrderIds = props.listOrder
		.filter((order) => {
			const orderId = Number(order.id);
			const status = Number(order.status);
			return (
				Number.isInteger(orderId) &&
				[OrderStatus.Paid, OrderStatus.Reserved, OrderStatus.Finish].includes(status)
			);
		})
		.map((order) => Number(order.id));
	const emailResendableOrderIdSet = new Set(emailResendableOrderIds);

	const adminVerifyEligibleOrderIds = props.listOrder
		.filter((order) => {
			const orderId = Number(order.id);
			const status = Number(order.status);
			return (
				Number.isInteger(orderId) &&
				[OrderStatus.Reserved, OrderStatus.NoShow].includes(status)
			);
		})
		.map((order) => Number(order.id));
	const adminVerifyEligibleOrderIdSet = new Set(adminVerifyEligibleOrderIds);

	const selectableOrderIds = Array.from(
		new Set<number>([...emailResendableOrderIds, ...adminVerifyEligibleOrderIds]),
	);
	const selectableOrderIdSet = new Set(selectableOrderIds);

	const selectedSelectableCount = selectableOrderIds.filter((id) => selectedOrderIds.includes(id)).length;
	const isAllSelectableSelected =
		selectableOrderIds.length > 0 && selectedSelectableCount === selectableOrderIds.length;
	const isSelectablePartial =
		selectedSelectableCount > 0 && selectedSelectableCount < selectableOrderIds.length;

	const selectedForVerifyCount = selectedOrderIds.filter((id) => adminVerifyEligibleOrderIdSet.has(id)).length;
	const tableMinWidth = Object.values(columnWidths).reduce((sum, val) => sum + val, 0);

	useEffect(() => {
		const visibleOrderIds = new Set(
			props.listOrder
				.map((order) => Number(order.id))
				.filter((orderId) => Number.isInteger(orderId)),
		);
		setSelectedOrderIds((prev) => prev.filter((orderId) => visibleOrderIds.has(orderId)));
		tableContainerRef.current?.scrollTo({ left: 0, behavior: "auto" });
	}, [props.listOrder]);

	const toggleOrderSelection = (orderId: number) => {
		if (!selectableOrderIdSet.has(orderId)) return;

		setSelectedOrderIds((prev) =>
			prev.includes(orderId) ? prev.filter((item) => item !== orderId) : [...prev, orderId],
		);
	};

	const toggleSelectAllSelectable = (checked: boolean) => {
		setSelectedOrderIds(checked ? selectableOrderIds : []);
	};

	const submitBulkSendBookingEmails = async () => {
		const idsForEmail = selectedOrderIds.filter((id) => emailResendableOrderIdSet.has(id));
		if (!idsForEmail.length) {
			openAlertDialog?.(
				AlertType.Fail,
				"Vui lòng chọn ít nhất 1 booking Confirmed, Reserve hoặc Finished (No-Show chỉ dùng để xác minh hàng loạt, không gửi mail).",
				() => {},
			);
			return;
		}

		setIsSendingBookingEmails(true);
		try {
			const response = await BulkSendBookingEmailByAdmin(idsForEmail);
			const sentCount = Number(response?.sentCount || 0);
			const totalCount = Number(response?.totalCount || idsForEmail.length);
			const failedResults = Array.isArray(response?.results)
				? response.results.filter((item: any) => item?.status !== "sent")
				: [];
			const failedSummary = failedResults
				.slice(0, 3)
				.map((item: any) => `#${item.id}: ${item.reason || "unknown error"}`)
				.join(" | ");

			setSelectedOrderIds(
				failedResults
					.map((item: any) => Number(item.id))
					.filter((orderId: number) => Number.isInteger(orderId)),
			);

			if (!failedResults.length) {
				openAlertDialog?.(
					AlertType.Success,
					`Đã gửi lại email thành công cho ${sentCount} booking tới khách hàng, station và admin.`,
					() => {},
				);
				return;
			}

			openAlertDialog?.(
				AlertType.Fail,
				`Đã gửi ${sentCount}/${totalCount} booking email. ${failedSummary ? `Cần kiểm tra thêm: ${failedSummary}` : ""}`,
				() => {},
			);
		} catch (error: any) {
			openAlertDialog?.(
				AlertType.Fail,
				error?.response?.data?.message || error?.message || "Không thể gửi lại email booking.",
				() => {},
			);
		} finally {
			setIsSendingBookingEmails(false);
		}
	};

	const confirmBulkSendBookingEmails = () => {
		const idsForEmail = selectedOrderIds.filter((id) => emailResendableOrderIdSet.has(id));
		if (!idsForEmail.length) {
			openAlertDialog?.(AlertType.Fail, "Vui lòng chọn ít nhất 1 booking Confirmed, Reserve hoặc Finished để gửi mail.", () => {});
			return;
		}

		openAlertDialog?.(
			AlertType.Confirm,
			`Gửi lại email xác nhận cho ${idsForEmail.length} booking đã chọn tới khách hàng, station và admin?`,
			() => {},
			() => submitBulkSendBookingEmails(),
			undefined,
			{
				declineText: "Hủy",
				acceptText: "Gửi mail",
			},
		);
	};

	const submitBulkVerifyArrival = async () => {
		const ids = selectedOrderIds.filter((id) => adminVerifyEligibleOrderIdSet.has(id));
		if (!ids.length) {
			openAlertDialog?.(
				AlertType.Fail,
				"Chọn ít nhất 1 booking Reserve hoặc No-Show để xác minh khách đã đến.",
				() => {},
			);
			return;
		}

		setIsBulkVerifying(true);
		try {
			const failures: string[] = [];
			for (const id of ids) {
				try {
					await adminVerifyOrderOverride(id, VerificationStatus.Verified);
				} catch (error: any) {
					failures.push(
						`#${id}: ${error?.response?.data?.message || error?.message || "lỗi"}`,
					);
				}
			}
			props.reload();
			if (!failures.length) {
				openAlertDialog?.(
					AlertType.Success,
					`Đã xác minh đã đến cho ${ids.length} booking (admin).`,
					() => {},
				);
				setSelectedOrderIds([]);
				return;
			}
			openAlertDialog?.(
				AlertType.Fail,
				`Hoàn thành một phần. Lỗi mẫu: ${failures.slice(0, 3).join(" | ")}`,
				() => {},
			);
		} catch (error: any) {
			openAlertDialog?.(
				AlertType.Fail,
				error?.response?.data?.message || error?.message || "Không thể xác minh hàng loạt.",
				() => {},
			);
		} finally {
			setIsBulkVerifying(false);
		}
	};

	const confirmBulkVerifyArrival = () => {
		const ids = selectedOrderIds.filter((id) => adminVerifyEligibleOrderIdSet.has(id));
		if (!ids.length) {
			openAlertDialog?.(
				AlertType.Fail,
				"Chọn ít nhất 1 booking Reserve hoặc No-Show.",
				() => {},
			);
			return;
		}

		openAlertDialog?.(
			AlertType.Confirm,
			`Xác minh khách đã đến (thay station) cho ${ids.length} booking? Trạng thái chuyển sang Confirmed (đã thanh toán).`,
			() => {},
			() => submitBulkVerifyArrival(),
			undefined,
			{
				declineText: "Hủy",
				acceptText: "Xác minh",
			},
		);
	};

	return (
		<React.Fragment>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					gap: 12,
					marginBottom: 12,
					flexWrap: "wrap",
				}}>
				<div style={{ fontSize: 14, color: "#4b5563" }}>
					Tích chọn: gửi lại mail cho <strong>Confirmed / Reserve / Finished</strong>; hoặc chọn{" "}
					<strong>Reserve / No-Show</strong> để admin xác minh khách đã đến hàng loạt.
					{" "}
					Mail gửi tới <strong>khách, station và admin</strong>. Đã chọn {selectedOrderIds.length} dòng
					{selectedForVerifyCount > 0 ? ` (${selectedForVerifyCount} có thể verify)` : ""}.
				</div>
				<div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
					<AdminTransactionAddButtton
						onClick={confirmBulkSendBookingEmails}
						disabled={
							!selectedOrderIds.some((id) => emailResendableOrderIdSet.has(id)) ||
							isSendingBookingEmails
						}>
						{isSendingBookingEmails ? "Đang gửi..." : "Gửi lại mail booking"}
					</AdminTransactionAddButtton>
					{user?.role === UserRole.Admin && (
						<AdminTransactionAddButtton
							onClick={confirmBulkVerifyArrival}
							disabled={!selectedForVerifyCount || isBulkVerifying}>
							{isBulkVerifying ? "Đang xác minh..." : `Xác minh đã đến (${selectedForVerifyCount})`}
						</AdminTransactionAddButtton>
					)}
				</div>
			</div>
			<MyBookingTableContainerAdmin
				ref={tableContainerRef}
				style={{ overflowX: "auto" }}>
				<Table
					aria-label="simple table"
					style={{ minWidth: tableMinWidth, tableLayout: "auto" }}>
					<TableHead>
						<TableRow>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.selection }}>
								<Checkbox
									color="primary"
									checked={isAllSelectableSelected}
									indeterminate={isSelectablePartial}
									disabled={!selectableOrderIds.length}
									onChange={(_, checked) => toggleSelectAllSelectable(checked)}
									inputProps={{ "aria-label": "select all bookings for mail or bulk verify" }}
								/>
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.id }}>
								ID
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.location }}>
								Station
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.customer }}>
								Người đặt
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.quantity }}>
								Số lượng
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.total }}>
								Tổng tiền
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.startDate }}>
								Ngày bắt đầu
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.endDate }}>
								Ngày kết thúc
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.status }}>
								Trạng thái
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.verification }}>
								Xác minh đến / No-show
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.createdAt }}>
								Ngày tạo
							</CommonTableHeadCell>
							<CommonTableHeadCell
								align="center"
								style={{ minWidth: columnWidths.actions }}>
								Thao tác
							</CommonTableHeadCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.listOrder.map((val, index) => (
							<BookingTableBodyAdmin
								key={index}
								val={val}
								dispute={disputes[String(val.id)] || null}
								reload={props.reload}
								isSelected={selectedOrderIds.includes(Number(val.id))}
								canSelectBookingRow={selectableOrderIdSet.has(Number(val.id))}
								onToggleSelection={toggleOrderSelection}
								setIsDialogLoginOpen={setIsDialogLoginOpen}
								setOrderId={setOrderId}
								setIsDialogIfOpen={setIsDialogIfOpen}
								setOrderIdInfo={setOrderIdInfo}
							/>
						))}
					</TableBody>
				</Table>
			</MyBookingTableContainerAdmin>
			{/* <MyBookingContainerMobi>
				{props.listOrder.map((val, index) => (
					<BookingMobi
						key={index}
						val={val}
						reload={props.reload}
						setIsDialogLoginOpen={setIsDialogLoginOpen}
						setOrderId={setOrderId}
					/>
				))}
			</MyBookingContainerMobi> */}

			<DialogUpdateOrderAdmin
				openDialog={isDialogLoginOpen}
				setOpenDialog={setIsDialogLoginOpen}
				orderId={orderId}
				reload={props.reload}
			/>
			<DialogInfoBookingAdmin
				openDialog={isDialogIfOpen}
				setOpenDialog={setIsDialogIfOpen}
				OrderId={orderIdInfo}
				reload={props.reload}
			/>
		</React.Fragment>
	);
}
